import { createReducer } from 'reduxsauce';
import { Types } from './types';
import { INITIAL_STATE } from './initialState';

export const userStripeSubscriptionsStart = state => ({
  ...state,
  isLoading: true,
  error: null,
});

export const userStripeSubscriptionsSuccess = (state, { data }) => ({
  ...state,
  data,
  isLoading: false,
});

export const userStripeSubscriptionsError = (state, { error }) => ({
  ...state,
  error,
  isLoading: false,
});

export const userStripeSubscriptionsCleanUp = () => INITIAL_STATE;

export const HANDLERS = {
  [Types.USER_STRIPE_SUBSCRIPTIONS_START]: userStripeSubscriptionsStart,
  [Types.USER_STRIPE_SUBSCRIPTIONS_SUCCESS]: userStripeSubscriptionsSuccess,
  [Types.USER_STRIPE_SUBSCRIPTIONS_ERROR]: userStripeSubscriptionsError,
  [Types.USER_STRIPE_SUBSCRIPTIONS_CLEAN_UP]: userStripeSubscriptionsCleanUp,
};

export default createReducer(INITIAL_STATE, HANDLERS);
